module.exports = __webpack_public_path__ + "static/media/buy_start_service_teach_2.0f479fa9.jpg";